export default "__VITE_ASSET__CrPKTbXx__"